module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "panels"
  }, [_c('DocumentUploader', {
    ref: "igazolasfeltolto"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Kiemelkedő sport tevékenység támogatás")]), _vm._v(" "), _c('HallgatoAdatok', {
    on: {
      "onReady": function (hallgato, hallgato_szakok) {
        this$1.save_enabled = true;
        this$1.hallgato = hallgato;
        this$1.hallgato_szakok = hallgato_szakok
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                Sportág\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.SportagID),
      expression: "form.SportagID"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "SportagID",
      "id": "SportagID"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.SportagID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sportagak), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.text))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "maxlength": "250",
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "Egyesulet",
      "label": "Egyesület",
      "name": "Egyesulet"
    },
    model: {
      value: (_vm.form.Egyesulet),
      callback: function($$v) {
        _vm.form.Egyesulet = $$v
      },
      expression: "form.Egyesulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('NemzetiBajnoksag'),
      "cstyle": "min-height: 100px",
      "placeholder": "Osztály, helyszín, időpont",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "NemzetiBajnoksag",
      "label": "Nemzeti bajnokság",
      "name": "NemzetiBajnoksag"
    },
    model: {
      value: (_vm.form.NemzetiBajnoksag),
      callback: function($$v) {
        _vm.form.NemzetiBajnoksag = $$v
      },
      expression: "form.NemzetiBajnoksag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('VilagBajnoksag'),
      "cstyle": "min-height: 100px",
      "placeholder": "Helyszín, időpont",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "VilagBajnoksag",
      "label": "Főiskolai Világbajnokság, Universade",
      "name": "VilagBajnoksag"
    },
    model: {
      value: (_vm.form.VilagBajnoksag),
      callback: function($$v) {
        _vm.form.VilagBajnoksag = $$v
      },
      expression: "form.VilagBajnoksag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('OrszagosBajnoksag'),
      "cstyle": "min-height: 100px",
      "placeholder": "Helyszín, időpont",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "OrszagosBajnoksag",
      "label": "Magyar Egyetemi-Főiskolai Országos Bajnokság",
      "name": "OrszagosBajnoksag"
    },
    model: {
      value: (_vm.form.OrszagosBajnoksag),
      callback: function($$v) {
        _vm.form.OrszagosBajnoksag = $$v
      },
      expression: "form.OrszagosBajnoksag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('Sportnapok'),
      "cstyle": "min-height: 100px",
      "placeholder": "Helyszín, időpont",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "Sportnapok",
      "label": "Országos Műszaki Felsőoktatási Sportnapok",
      "name": "Sportnapok"
    },
    model: {
      value: (_vm.form.Sportnapok),
      callback: function($$v) {
        _vm.form.Sportnapok = $$v
      },
      expression: "form.Sportnapok"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "tooltipDescription": _vm.getTooltipDescriptionByKey('Egyeb'),
      "cstyle": "min-height: 100px",
      "placeholder": "Helyszín, időpont",
      "maxlength": "1000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "Egyeb",
      "label": "Egyéb eredmények",
      "name": "Egyeb"
    },
    model: {
      value: (_vm.form.Egyeb),
      callback: function($$v) {
        _vm.form.Egyeb = $$v
      },
      expression: "form.Egyeb"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'leirasok') ? _c('div', {
      staticClass: "form-error",
      staticStyle: {
        "position": "relative",
        "top": "-19px"
      },
      attrs: {
        "id": "leirasok"
      }
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nyilatkozat),
      expression: "form.nyilatkozat"
    }],
    attrs: {
      "id": "nyilatkozat",
      "name": "nyilatkozat",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.nyilatkozat) ? _vm._i(_vm.form.nyilatkozat, "1") > -1 : (_vm.form.nyilatkozat)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.nyilatkozat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.nyilatkozat = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.nyilatkozat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.nyilatkozat = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozat') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Beküld")])])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Kiemelkedő sport tevékenység támogatás")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }, [_vm._v(_vm._s(_vm.fill_info))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Pályázati adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Az intézményen kívüli sportolók eredményeiről "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("igazolást")]), _vm._v(" kell adni! A pályázatról a Hallgatói Térítések és Juttatások Szabályzatának 6.§-a rendelkezik.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Hallgatói nyilatkozat")]), _vm._v(" "), _c('div', {
    staticClass: "form-scroll-block"
  }, [_vm._v("A jelentkezési lapon szereplő személyes adatok kezelése az érintett önkéntes hozzájárulásán alapul, mely hozzájárulást az érintett a pályázati adatlap kitöltésével és annak aláírásával ad meg."), _c('br'), _c('br'), _vm._v("Az adatkezelők harmadik személy(ek) részére adattovábbítást nem végeznek."), _c('br'), _c('br'), _vm._v("Az érintett hozzájárulása indokolás nélkül bármikor visszavonható."), _c('br'), _c('br'), _vm._v("A kezelt adatokba betekintést kizárólag az adatkezelők ösztöndíj elnyerésére való jogosultság megállapításával, annak elbírálásával, valamint az ösztöndíj folyósításával összefüggő feladatokat ellátó munkatársa(i) nyerhet(nek) a fenti feladatok ellátásához szükséges ideig és mértékben. A jelentkezési lapon szereplő adatok a jelentkezés sikertelensége esetén az elbírálást követő 1 hónapig kezelhetőek."), _c('br'), _c('br'), _vm._v("Pozitív elbírálás esetén a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 pályázat keretében az ösztöndíjas hallgatóról megismert személyes adatokat az ösztöndíjszerződés lejáratát követő 8 évig jogosult kezelni."), _c('br'), _c('br'), _vm._v("Az érintett az adatkezelés teljes időtartama alatt élhet az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvényben biztosított jogával, (tájékoztatáshoz, helyesbítéshez, törléshez, zároláshoz, tiltakozáshoz való jog) továbbá jogsérelem esetén bírósághoz, valamint a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest, Szilágyi Erzsébet fasor 22/c., tel.: 06-1-391-1400, honlap URL címe: http://naih.hu, elektronikus levelezési cím: ugyfelszolgalat@naih.hu ) is fordulhat.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozat"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n              Büntetőjogi felelősségem tudatában tudomásul veszem a fentieket\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19e0dae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/kiemelkedo_sport_tamogatas.vue
// module id = 333
// module chunks = 0